import { AxiosInstance } from 'axios';
import {
    VersionsListResponse,
    VersionItemEdit,
    VersionItemAdd,
    GetVersionsQueryParams,
} from 'models/api/versions';
import Id from 'models/id';

const controller = '/versions'
const blockController = '/blocks'

export const getVersions = async (axios: AxiosInstance, params: GetVersionsQueryParams) => {
    const { data } = await axios.get<VersionsListResponse>(controller, { params });
        return data;
};

export const createVersion = async (axios: AxiosInstance, item: VersionItemAdd) =>
    await axios.post<Id>(controller, item);

export const updateVersion = async (axios: AxiosInstance, item: VersionItemEdit) => {
    await axios.put<null>(controller + `/${item.id}`, item);
};

export const deleteVersion = async (axios: AxiosInstance, id: string) =>
    await axios.delete<null>(controller + `/${id}`);

export const setVersionStatus = async (axios: AxiosInstance, id: string, status: string) =>
    await axios.patch<null>(controller + `/${id}/statuses/${status}`);

export const setVersionBlock = async (axios: AxiosInstance, version_id: string) =>
    await axios.post<null>(blockController, { version_id });
